import { Controller } from "@hotwired/stimulus"

// Modal podglądu notatki. Dane leada przychodzą z data-* atrybutów
// przycisku oka (patrz _lead_row.html) — nie trzeba fetchować.
export default class extends Controller {
  static targets = ["overlay", "code", "cat", "region", "fresh", "score", "note", "price", "addBtn"]

  open(event) {
    const d = event.currentTarget.dataset
    this.codeTarget.textContent   = d.previewCode
    this.catTarget.textContent    = d.previewCat
    this.regionTarget.textContent = d.previewRegion
    this.freshTarget.textContent  = d.previewFresh
    this.noteTarget.textContent   = d.previewNote
    this.priceTarget.textContent  = d.previewPrice

    // badge potencjału
    this.scoreTarget.textContent = d.previewScore
    this.scoreTarget.className = "ls-badge ls-badge--" +
      ({ hot: "hot", warm: "warm", new: "new" }[d.previewScoreKind] || "new")

    // zapamiętaj ID, by "Dodaj do koszyka" w modalu działało
    this.addBtnTarget.dataset.cartIdParam = d.previewId || event.currentTarget.closest(".ls-lead-row")?.dataset.leadId || ""

    // Dwustopniowo: pokaż (display), potem następna klatka → klasa is-open uruchamia fade+scale.
    this.overlayTarget.hidden = false
    this._raf = requestAnimationFrame(() => {
      if (this.hasOverlayTarget) this.overlayTarget.classList.add("is-open")
    })
  }

  close() {
    if (!this.hasOverlayTarget) return
    // Anuluj pending rAF z open — inaczej spóźniony callback dodałby is-open po zamknięciu.
    if (this._raf) cancelAnimationFrame(this._raf)
    const overlay = this.overlayTarget
    overlay.classList.remove("is-open")
    // Ukryj dopiero po animacji wyjścia (chyba że w międzyczasie ktoś znów otworzył).
    setTimeout(() => {
      if (!overlay.classList.contains("is-open")) overlay.hidden = true
    }, 180)
  }

  backdropClose(event) {
    if (event.target === this.overlayTarget) this.close()
  }

  stop(event) { event.stopPropagation() }

  // Deleguj do kontrolera koszyka i zamknij modal.
  addToCart() {
    const id = this.addBtnTarget.dataset.cartIdParam
    const btn = document.querySelector(`.ls-add-btn[data-cart-id-param="${id}"]`)
    if (btn && !btn.classList.contains("is-in-cart")) btn.click()
    this.close()
  }
}
